
import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import useAuth from '../../../hooks/useAuth';
import VerificationModal from './EmailVerificationModal';
export default function VerificationGuard({ children }) {
  const { user, isLoading, refreshUser } = useAuth();


  /* --- Logic Flow for Tiers and Status --- */
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  const handleVerificationSuccess = () => {
    setTimeout(() => {
      refreshUser();
    }, 1500);
  };

  if (user && !user.isVerified) {
    return <VerificationModal open={true} onSuccess={handleVerificationSuccess} />;
  }
  
  return children;
}